import CircularProgress from "@mui/material/CircularProgress";
import dynamic from "next/dynamic";

const CalendarDynamic = dynamic(() => import("./calendar"), {
  loading: () => <CircularProgress />,
});

export default CalendarDynamic;
